import { EnIvcfDisability } from '../../enum/medlogic/en-ivcf-disability.enum';

export interface IDisability {
  css?: string;
  enIvcfDisability: EnIvcfDisability;
  checked: boolean;
}